const APP_STORE_LINK = "https://apps.apple.com/us/app/id1526022293";
const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.characterdaily.devnow";

export { APP_STORE_LINK, PLAY_STORE_LINK };
